<svg-icon class="h-60 absolute -left-43 bottom-3 cloud-left" [src]="'cloud'"></svg-icon>
<svg-icon class="h-60 absolute -right-43 top-3 cloud-right" [src]="'cloud'"></svg-icon>
<div class="flex flex-col h-full w-full justify-center items-center absolute font-main transform scale-150">
  <svg-icon class="h-14 w-34 mb-5" [src]="'not-found-404'"></svg-icon>
  <p class="text-2xl text-navy-80">{{ 'routeNotFound' | translate }}</p>
</div>
